import { Button } from '@appcues/sonar';
import styled from 'styled-components';

const ButtonLink = styled(Button)`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

export default ButtonLink;
